<template>
  <div class="wrapper">
    <div class="content-container">
      <div class="stingy-card">

<h2>🍁 Oh Canada: A Land of Awe and... Taxes? 🐾</h2>


<p>Hey there, financial explorer! 🌟 Ready to embark on a journey across the grand tapestry of Canada? But hold your snowshoes! Before you marvel at the Rocky Mountains, get lost in the vastness of the Prairies, or indulge in the vibrant city life of Toronto and Vancouver, there's something quirky you should know. Yes, Canada's beauty is as boundless as the Northern skies, but living in this maple-syrup-loving land comes with its own unique "tax-terroir". 🐱</p>
<p>Welcome to RiskyPaws' interactive taxscape! 🌍 Dive into our meticulously crafted map, not just to find your next adventure but to unravel the fiscal secrets each province coyly hides. From the rugged cliffs of Newfoundland to the serene shores of British Columbia, every province sings a different tax tune. 🎶</p>
<p>Did you know that Quebec's joie de vivre is matched with its distinct tax policies? Or that Alberta's oil-rich lands reflect in its tax structure? Our map is more than just lines and names; it's a gateway to understanding how each region balances its charm with its charges. 💰</p>
<p>So, whether you're planning to settle in the serene Yukon or navigate the bustling streets of Ontario, RiskyPaws is here to guide you through the forest of figures and the maze of margins. Let's paw-sitively ensure your financial savvy travels with you as you explore the splendor of Canada. 🏞️</p>
<p>And hey, while you're at it, why not plan your budget to include some extra poutine and beavertails? After all, exploring Canada's fiscal landscape should be as delightful as savoring its culinary delights. Bon voyage, and happy tax-trailing! 🚀</p>
<iframe height="1000" style="width: 100%;" scrolling="no" title="Canada and Taxation Across Provinces and Territories" src="https://codepen.io/Farah-Kamal/embed/Baveqed/bf228fc0f8785fe307f1d02ea164c6fc?default-tab=result&theme-id=47174" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
  See the Pen <a href="https://codepen.io/Farah-Kamal/pen/Baveqed/bf228fc0f8785fe307f1d02ea164c6fc">
  Canada and Taxation Across Provinces and Territories</a> </iframe>

  </div></div></div>


</template>

<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}
</style>